import { useState, useEffect } from "react";
import Navbar from "../Side-Navbar/Navbar";
import Sidebar from "../Side-Navbar/Sidebar";

function MainLayout({ children }) {
  const [sidebarMode, setSidebarMode] = useState("lead");
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem('sidebarOpen') === 'true' && window.innerWidth >= 1024
  );

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1024) {
        setIsSidebarOpen(false);
        localStorage.setItem('sidebarOpen', false);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggleSidebarMode = (newMode) => {
    setSidebarMode(newMode);
  };

  const toggleSidebar = () => {
    const newState = !isSidebarOpen;
    setIsSidebarOpen(newState);
    localStorage.setItem('sidebarOpen', newState);
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-800">
      {/* Fixed Navbar - Always on top */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 shadow-md">
        <Navbar 
          onToggleSidebarMode={handleToggleSidebarMode} 
          isSidebarOpen={isSidebarOpen}
          onToggleSidebar={toggleSidebar}
        />
      </div>

      {/* Sidebar - Below navbar */}
      <div 
        className={`fixed top-16 bottom-0 left-0 z-40 ${
          isSidebarOpen ? 'w-72' : 'w-0'
        } transition-all duration-300 overflow-hidden`}
      >
        <Sidebar 
          mode={sidebarMode} 
          isOpen={isSidebarOpen} 
          onToggle={toggleSidebar} 
        />
      </div>

      {/* Mobile overlay */}
      {isSidebarOpen && (
        <div
          className="fixed inset-0  backdrop-blur-sm z-30 lg:hidden"
          style={{ top: '64px' }}
          onClick={() => toggleSidebar()}
        />
      )}

      {/* Main content area with proper spacing */}
      <main 
        className={`pt-16 min-h-screen transition-all duration-300 ${
          isSidebarOpen ? 'lg:ml-[280px]' : 'lg:ml-0'
        }`}
      >
        <div className="">
          {children}
        </div>
      </main>
    </div>
  );
}

export default MainLayout;
